import React from 'react';
import Icon from '../Icon';
import { $OpenButton, $OpenButtonWrapper } from './OpenRowButton.styled';

interface OpenRowButtonProps {
  isClickable: boolean;
}

const OpenRowButton = ({ isClickable }: OpenRowButtonProps) => (
  <$OpenButtonWrapper>
    <$OpenButton $isClickable={isClickable}>
      <Icon name="OpenPage" size={12} />
      OPEN
    </$OpenButton>
  </$OpenButtonWrapper>
);

export default OpenRowButton;
